module.exports = __webpack_public_path__ + "static/bakeryslide-05-min-ab04693ef7f790b9805c532de00d901a.jpg";